import React from 'react'
import {GlobalStyle} from './components/styles/GlobalStyles'
import DataVisualisations from './components/pages/DataVisualisations';
import Header from './components/components/Header/Header';
import Footer from './components/components/Footer/Footer';
import { Route } from 'react-router-dom'
import ScrollContextProvider from './components/context/ScrollContext';
import mainContentData from './assets/data/mainContent';
import colorRange from "./components/styles/bodyColors"
import _ from "lodash"

const randomColor = colorRange[_.random(0, colorRange.length - 1)]

function App() {
  return (
    <>
      <ScrollContextProvider>
          <GlobalStyle
            mainColor={randomColor}
          />
          <Route exact path={"/"} component={Header}/>
          <Route exact path={"/"} component={DataVisualisations}/>
          {
            mainContentData.map(el => ( 
              el.component !== 'none'
                &&
              <Route exact path={`${el.link}`} component={el.component}/>
            ))
          }
          <Route exact path={"/"} component={Footer}/>
      </ScrollContextProvider>
    </>
  );
}

export default App;
